module.exports = __webpack_public_path__ + "static/media/favicon.f3361929.png";